<template>
    <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
      <v-col cols='12'>
        <v-row class="text-center" justify="start" height='90vh' style="margin: 0 0">
          <v-btn text color="orange" @click='$router.push("battleCards")'>Return to Main Menu</v-btn>
        </v-row>
        <v-row class="text-center" justify="start" height='90vh' style="margin: 0 0" v-if='!packDrawn'>
          <v-col cols="2">
            <v-hover v-slot:default="{ hover }">
              <v-card @click='drawCards("BDSM")'>
                <v-card-actions>
                  BDSM
                  <v-spacer></v-spacer>
                  <v-icon color='green'>mdi-cash-minus</v-icon>
                  5
                </v-card-actions>
                <v-img
                  src='https://i.imgur.com/0r669Fq.jpg'
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="300px"
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-1 white--text"
                      style="height: 100%;"
                    >
                    Cards with a focus on high defense and low cost or high offense and high cost.
                    </div>
                  </v-expand-transition>
                </v-img>
                <v-card-actions>
                  {{BDSMPackSize}} / 12 remaining
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="2">
            <v-hover v-slot:default="{ hover }">
              <v-card @click='drawCards("Bimbo")'>
                <v-card-actions>
                  Bimbo
                  <v-spacer></v-spacer>
                  <v-icon color='green'>mdi-cash-minus</v-icon>
                  10
                </v-card-actions>
                <v-img
                  src='https://i.imgur.com/taLRtGR.jpg'
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="300px"
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-1 white--text"
                      style="height: 100%;"
                    >
                    Cards with high cost that will either greatly or permantently boost attack and defense.
                    </div>
                  </v-expand-transition>
                </v-img>
                <v-card-actions>
                  {{bimboPackSize}} / 12 remaining
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row class="text-center" justify="center" height='90vh' style="margin: 0 0" v-if='packDrawn'>
          <v-col cols='12'>
            <h1>Cards drawn</h1>
          </v-col>
          <v-col cols='12'>
            <v-btn color='green' text @click='packDrawn = false'>Select Another Pack</v-btn>
          </v-col>
          <v-col cols="2" v-for="card in drawnCards">
            <v-card :color='card.color'>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-icon color='green'>mdi-cash-minus</v-icon>
                {{card.cost}}
              </v-card-actions>
              <v-img
                :src="card.src"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="300px"
              >
                <v-card-title v-text="card.title"></v-card-title>
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>

                <div v-if="!!card.modifiers[0]">
                  <v-icon color='orange'>mdi-cards</v-icon>
                  {{card.modifiers[0]}}
                </div>

                <div v-if="!!card.modifiers[1]">
                  <v-icon color='blue'>mdi-shield</v-icon>
                  {{card.modifiers[1]}}
                </div>

                <div v-if="!!card.modifiers[2]">
                  <v-icon color='red'>mdi-sword</v-icon>
                  {{card.modifiers[2]}}
                </div>

                <div v-if="!!card.modifiers[3]">
                  <v-icon color='green'>mdi-cash-plus</v-icon>
                  {{card.modifiers[3]}}
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        </v-col>
    </v-row>
</template>

<script>
  export default {
    name: 'battleCardsDeckBuilder',
    data: () => ({
      packDrawn: false,
    }),
    computed: {
      drawnCards () {
        return this.$store.state.battleCardsDrawn;
      },
      BDSMPackSize () {
        return this.$store.state.battleCardsBDSM.length;
      },
      bimboPackSize () {
        return this.$store.state.battleCardsBimbo.length;
      }
    },
    methods: {
      drawCards(set){
        this.$store.dispatch('drawCards', set);
        this.packDrawn = true;
      },
    }
  }
</script>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .7;
    position: absolute;
    width: 100%;
    background-color: black;
    cursor: pointer;
  }
</style>